"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.default = (function (callback, buffer) {
    var calledRef = react_1.default.useRef(false);
    var timeoutRef = react_1.default.useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        if (!calledRef.current || force === true) {
            if (callback() === false) {
                // Not delay since callback cancelled self
                return;
            }
            calledRef.current = true;
            cancelTrigger();
            timeoutRef.current = window.setTimeout(function () {
                calledRef.current = false;
            }, buffer);
        }
        else {
            cancelTrigger();
            timeoutRef.current = window.setTimeout(function () {
                calledRef.current = false;
                trigger();
            }, buffer);
        }
    }
    return [
        trigger,
        function () {
            calledRef.current = false;
            cancelTrigger();
        },
    ];
});
//# sourceMappingURL=useBuffer.js.map